// Core
import React, {Component} from 'react';
import {Grid, Row, Col} from 'react-flexbox-grid';
import Subheader from 'material-ui/Subheader';
import {connect} from "react-redux";
import uuid from 'uuid';
import ActivityIndicator from 'react-activity-indicator';
import FlatButton from 'material-ui/FlatButton';
import _ from 'lodash';

// Components
import IssuesView from '../issues/Issues';
import FilterPanel from '../../components/FilterPanel';
import DocumentsList from '../../components/DocumentsList';
import CategoriesList from '../../components/CategoriesList';
import LocationsList from '../../components/LocationsList';
import CategoriesModal from './CategoriesModal';

// Actions
import {getFilesByProjectId, clearProjectFiles, setFilter} from '../../redux/files/actions';
import {createPost} from '../../redux/issues/actions';
import {getProject, updateProjectLogo, getUserProjects} from '../../redux/projects/actions';
import {getProjectLocations} from '../../redux/locations/actions';
import { setProjectId } from "../../redux/checklists/actions";
import {track} from '../../redux/auth/actions';

// Selectors
import * as selectors from '../../redux/projects/selectors';
import * as fileSelectors from '../../redux/files/selectors';
import * as authSelectors from '../../redux/auth/selectors';
import * as projectSelectors from '../../redux/projects/selectors'

// Instruments
import {categoriesOriginal} from '../../fixtures/categories';
import {getImagePreviewUrl, FileStackClient} from '../../services/FileStackService';

// Styles & assets
import defaultProjectImage from '../../assets/default-project.jpg';
import './ProjectDetails.css';
import * as checklistSelectors from "../../redux/checklists/selectors";

const mapStateToProps = (state) => ({
  project: selectors.projectDetails(state),
  projectFiles: fileSelectors.projectFiles(state),
  isFetching: fileSelectors.filesIsFetching(state),
  searchEnabled: fileSelectors.fileSearchEnabled(state),
  filesSearchList: fileSelectors.fileSearchList(state),
  isSearchFetching: fileSelectors.fileSearchIsFetching(state),
  filter: fileSelectors.getFilter(state),
  accessToken: authSelectors.getAccessToken(state),
  userProfile: authSelectors.getUserProfile(state),
  locations: state.locations.projectsLocation,
  checklistProjectId: checklistSelectors.checklistProjectId(state),
  projectsList: projectSelectors.projectsList(state),
});

const mapDispatchToProps = {
  getProject,
  getFilesByProjectId,
  getProjectLocations,
  clearProjectFiles,
  setFilter,
  createPost,
  track,
  updateProjectLogo,
  getUserProjects,
  setProjectId,
};

class ProjectsScreen extends Component {

  state = {
    filter: false,
    groups: {},
    album: {},
    filesByLocations: {},
    barHidden: true,
    selectedFiles: [],
    uploadedFiles: null,
    issueTable: false

  };

  componentDidMount() {
    const { history, track, getProjectLocations, getUserProjects } = this.props;
    const { location } = history;
    const { projectId } = this.props.match.params;
    const { userId } = JSON.parse(localStorage.getItem("auth0")) || "";

    getUserProjects(userId);
    getProjectLocations(projectId);

    if (!this.componentHasData()) {
      this.componentUpdateData();
    }

    if (location.state && location.state.action === 'upload') {
      track('Web app: Redirected from email link');

      this._handleUpload();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps === this.props) {
      return;
    }

    if (!this.componentHasData()) {
      this.componentUpdateData(nextProps);
    }

    if (nextProps.checklistProjectId !== this.props.checklistProjectId) {

      this.props.getFilesByProjectId(nextProps.checklistProjectId);
      this.props.getProject(nextProps.checklistProjectId);
    }

    if (Object.keys(nextProps.projectsList).length !== Object.keys(this.props.projectsList).length) {
      const firstProjectId = Object.values(nextProps.projectsList)[0].id;

      const { setProjectId } = this.props;
      setProjectId(firstProjectId);
    }
  }

  componentWillUnmount() {
    this.props.clearProjectFiles();
  }

  componentHasData() {
    const {project, projectFiles} = this.props;

    if (!project) {
      return false;
    }

    return Object.keys(project).length > 0 && projectFiles !== false && Object.keys(this.state.album) > 0;
  }

  componentUpdateData(props = this.props) {
    const {project, projectFiles, checklistProjectId} = props;
    if (checklistProjectId) {
      const projectId = checklistProjectId;

      if (projectId === 'PRIVATE') {
        return;
      }

      if ((props.checklistProjectId !== this.props.checklistProjectId) || !Object.keys(project).length ) {
        this.props.getProject(projectId);
      }

      if (projectFiles !== null && !projectFiles && !Object.keys(projectFiles).length) {
        this.props.getFilesByProjectId(projectId);
      }

      if (projectFiles && Object.keys(projectFiles).length) {
        this.prepareCategories(projectFiles);
        this.prepareLocations(projectFiles);
      }
    }
  }

  prepareLocations(files) {
    const locationsObj = {
      general: {
        location: {
          id: 'General',
          title: 'General',
          symbol: 'GN'
        },
        files: []
      }
    }

    Object.values(files).forEach(file => {
      if (!file.location) {
        return locationsObj.general.files.push(file);
      }

      if (locationsObj[file.location.name]) {
        locationsObj[file.location.name].files.push(file)
      } else {
        locationsObj[file.location.name] = {
          location: {
            id: file.location.id,
            title: file.location.name,
            symbol: file.location.name.slice(0, 2).toUpperCase()
          },
          files: [file]
        }
      }
    })

    this.setState({ filesByLocations: Object.values(locationsObj) })
  }

  prepareCategories(files) {
    let dataForAlbum = {};
    Object.keys(files).map((fileId) => {
      const file = files[fileId];
      if (file.categories) {
        file.categories.map((categoryId) => {

          if (!dataForAlbum[categoryId]) {
            dataForAlbum[categoryId] = {category: categoriesOriginal[categoryId], files: []};
          }

          dataForAlbum[categoryId].files.push(file);
        });
      } else {
        if (!dataForAlbum["noCategory"]) {
          dataForAlbum["noCategory"] = {
            category: {
              id: "noCategory",
              title: 'No categories',
              symbol: "NC"
            },
            files: []
          };
        }

        dataForAlbum["noCategory"].files.push(file);
      }
    });
    dataForAlbum = _.sortBy(dataForAlbum, (item) => {
      return item.files.length;
    }).reverse();

    this.setState({
      album: dataForAlbum
    })
  }

  _handleSetFilter = (filter) => {
    this.setState({
      filter
    }, () => {
      this.props.setFilter(filter);
    });
  };

  _handleGroupsCollect = (groups) => {
    this.setState({
      groups
    })
  };

  clearUploaded = () => {
    this.setState({uploadedFiles: null})
  };

  uploadFiles = async ({ categories, fileType, location }) => {
    const {createPost, accessToken, userProfile, project, checklistProjectId } = this.props;
    const uploadedFiles = [...this.state.uploadedFiles];
    // const { projectId } = this.props.match.params;
    const now = new Date().getTime();

    const projectId = checklistProjectId;

    let messageEntity = {
      title: '',
      createdAt: now,
      updatedTS: now,
      owner: {},
      issueNumber: {},
      id: '',
      images: []
    };

    let files = {};
    uploadedFiles.forEach((file) => {
      const id = uuid.v4();

      files[id] = {
        id: id,
        createdAt: now,
        updatedAt: now,
        categories: categories,
        sharedWith: [],
        owner: '', //get user id
        issues: [], //get message id
        name: file.filename,
        metadata: {
          mimetype: file.mimetype
        },
        filestackId: file.handle,
        type: file.filename && file.filename.match(/\.(jpeg|jpg|gif|png|JPG|PNG|GIF|JPEG)$/) != null ? 'photo' : 'document',
        uri: file.url,
        folder: fileType || 'General',
        location: location || null
      }
    });

    await createPost(projectId, messageEntity, files, userProfile, true, project);

    this.clearUploaded();
    this.props.clearProjectFiles();
    this.props.getFilesByProjectId(projectId);
  };

  _handleUpload = () => {
    FileStackClient.picker({
      maxFiles: 1,
      fromSources: [
        "local_file_system",
        "googledrive",
        "dropbox",
        "gmail",
        "box",
        "onedrive",
        "clouddrive"
      ],
      onUploadDone: (res) => {
        const { filesUploaded } = res;
        this.setState({uploadedFiles: filesUploaded});
      }
    }).open();
  };

  openIssuesTable = () => this.setState({issueTable: true});
  closeIssuesTable = () => this.setState({issueTable: false});

  render() {
    const {filter, project, projectFiles, filesSearchList, searchEnabled, isFetching, locations} = this.props;
    const {projectId} = this.props.match.params;
    const {album, uploadedFiles, issueTable, filesByLocations} = this.state;


    return (
      <div className='dashboard-page-wrap'>
        <CategoriesModal open={!!uploadedFiles} onConfirm={this.uploadFiles} locations={locations[projectId]}/>
        <Grid fluid className="dashboard-page dashboard-page-small">
          <Row top="xs">
            <Col xs={12}>
              {/*{Object.keys(project).length > 0 &&*/}
              {/*<Row>*/}
              {/*  <Col xs={12}>*/}
              {/*    <div className="project-details">*/}
              {/*      <div className="details">*/}
              {/*        <FlatButton backgroundColor="#6da92e" hoverColor="#83BA2C" labelStyle={{color: '#fff'}} fullWidth label="Upload files" onClick={this._handleUpload} />*/}
              {/*      </div>*/}
              {/*    </div>*/}
              {/*  </Col>*/}
              {/*</Row>*/}
              {/*}*/}
              {projectFiles !== null && Object.keys(projectFiles).length > 0 && !issueTable &&
                <Row>
                  <Col xs={12}>
                    {Object.keys(album).length > 0 &&
                      <Row start="xs">
                        <Col xs={12}>
                          <Subheader className="subheader categories-list-subheader">Categories</Subheader>
                          <CategoriesList projectId={projectId} categories={album}/>
                        </Col>
                      </Row>
                    }
                    {filesByLocations.length > 0 &&
                      <Row start="xs">
                        <Col xs={12}>
                          <Subheader className="subheader categories-list-subheader">Locations</Subheader>
                          <LocationsList project={project} locations={filesByLocations}/>
                        </Col>
                      </Row>
                    }
                    <FilterPanel filter={filter} onChange={this._handleSetFilter}/>
                    <DocumentsList
                      filesList={projectFiles}
                      searchEnabled={searchEnabled}
                      filesSearchList={filesSearchList}
                      filter={filter}
                      onGroupsCollect={this._handleGroupsCollect}
                    />
                  </Col>
                </Row>
              }
              {projectFiles !== null && isFetching && !projectFiles && !issueTable &&
              <Row center="xs" middle="xs" className="activity-wrapper">
                <Col xs={12}>
                  <ActivityIndicator
                    number={5}
                    diameter={40}
                    duration={100}
                    activeColor="#5BA22F"
                    borderColor="white"
                    borderWidth={5}
                    borderRadius="50%"
                  />
                </Col>
              </Row>
              }
              {projectFiles == null && !isFetching && !issueTable &&
              <Row center="xs" middle="xs" className="activity-wrapper">
                <Col xs={12}>
                  <h2>Files list is empty</h2>
                </Col>
              </Row>
              }
              {/*{issueTable && <Issues location={project.location} members={project.members}/>}*/}
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectsScreen);
